import { post, get } from '../utils/api';

// User login
export const loginUser = async (email, password, role) => {
  return await post('/api/auth/signin', { email, password, role });
};

// Google Sign-In — credential is the ID token JWT from Google Identity Services.
// referralCode is only used by the server when this creates a NEW account.
export const googleSignIn = async (credential, role, referralCode) => {
  return await post('/api/auth/google', referralCode ? { credential, role, referralCode } : { credential, role });
};

// User registration
export const registerUser = async (userData, role) => {
  return await post('api/auth/signup', { ...userData, roleName: role });
};

// ── Email + mobile OTP on the registration form, before the account exists ──
// Which addresses must be verified (mobile only once SMS is switched on).
export const getRegisterOtpConfig = async () => {
  return await get('/api/auth/register-otp/config');
};

// channel: 'email' | 'mobile'
export const sendRegisterOtp = async (channel, target) => {
  return await post('/api/auth/register-otp/send', { channel, target });
};

// Returns { verificationToken } — sent with the signup as proof.
export const verifyRegisterOtp = async (channel, target, otp) => {
  return await post('/api/auth/register-otp/verify', { channel, target, otp });
};

// OTP verification
export const verifyOtp = async (userData) => {
  return await post('/api/auth/verify-otp', userData);
};

// Resend OTP
export const resendOtp = async (email) => {
  return await post('/auth/resend-otp', { email });
};

// Forgot password
export const forgotPassword = async (email) => {
  return await post('/auth/forgot-password', { email });
};

// Reset password
export const resetPassword = async (token, newPassword) => {
  return await post('/auth/reset-password', { token, newPassword });
};

// Change password
export const changePassword = async (currentPassword, newPassword) => {
  return await post('/auth/change-password', { currentPassword, newPassword });
};

// Check if email exists
export const checkEmailExists = async (email) => {
  return await post('/api/auth/check-email', { email });
};

// User logout
export const logoutUser = async () => {
  return await post('/auth/logout', {});
};

// Get current user profile
export const getCurrentUser = async () => {
  return await get('/auth/me');
};

// Check token validity
export const checkTokenValidity = async () => {
  return await get('/auth/validate-token');
};